module.exports = __webpack_public_path__ + "media/icon_transaction/cat_1-277e3618.png";